/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_View_Full_PdfInputs */

const en_public_docs_view_full_pdf = /** @type {(inputs: Public_Docs_View_Full_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See full PDF`)
};

const es_public_docs_view_full_pdf = /** @type {(inputs: Public_Docs_View_Full_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver PDF completo`)
};

/**
* | output |
* | --- |
* | "See full PDF" |
*
* @param {Public_Docs_View_Full_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_view_full_pdf = /** @type {((inputs?: Public_Docs_View_Full_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_View_Full_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_view_full_pdf(inputs)
	return en_public_docs_view_full_pdf(inputs)
});